import { render, staticRenderFns } from "./bill_overlay.vue?vue&type=template&id=2953c728&scoped=true"
import script from "./bill_overlay.vue?vue&type=script&lang=js"
export * from "./bill_overlay.vue?vue&type=script&lang=js"
import style0 from "./bill_overlay.vue?vue&type=style&index=0&id=2953c728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953c728",
  null
  
)

export default component.exports